import React from 'react';

import ChoiceBubble from '../ChoiceBubble/ChoiceBubble';
import styles from './SingleChoiceBubbleSelect.module.scss';

const SingleChoiceBubbleSelect = ({
  choices,
  onChoiceSelect,
  selectedChoiceId,
  classes = {},
}: any) => {
  const renderChoiceBubbles = () => {
    return choices.map((choice: any) => {
      return (
        <li
          className={ `${styles.Choice} ${classes.Li}` }
          key={ `choice-${choice.id}` }
        >
          <ChoiceBubble
            choice={ choice }
            classes={ classes }
            isSelected={ !!(selectedChoiceId && Number(selectedChoiceId) === Number(choice.id)) }
            onClick={ onChoiceSelect }
          />
        </li>
      );
    });
  };

  return (
    <ul className={ `${styles.Choices} ${classes.Ul}` }>
      { renderChoiceBubbles() }
    </ul>
  );
};

export default SingleChoiceBubbleSelect;
